module.exports = __webpack_public_path__ + "img/icone_docs.8866cf21.png";